import React, { useContext, useEffect } from 'react';
import Authentication from '../../../../libs/api/services/Authentication';
import Questionnaire from '../../../../libs/api/services/Questionnaire';
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider';

const QuestionnaireConfigContext = React.createContext();

export function QuestionnaireConfigProvider({ children }) {
    const { setToastPerm, showError } = useContext(CommonFunctionsContext)
    // const [state, setState] = useState({})
    // useEffect(() => {
    //     setToastPerm({
    //         show: true, children:
    //             <div className='d-flex align-items-center' > This questionnaire requires approval <button className='btn text-light' > Approve</button></ div>
    //     })
    // }, [])

    useEffect(() => {
        return () => setToastPerm({ show: false })
    }, [])

    const setActiveQuestionnaire = (questionnaire, callback) => {
        if (Authentication.getFacility() !== '-1') return
        if (!questionnaire.approved && questionnaire.type !== 'System')
            setToastPerm({
                show: true, children:
                    <div className='d-flex align-items-center'>
                        This questionnaire requires approval
                        <button className='btn text-light' onClick={e =>
                            Questionnaire.ApproveQuestionnaire(questionnaire.id)
                                .then(r => { if (callback) callback(); setToastPerm({ show: false }) })
                                .catch(e => showError(e))
                        } > Approve</button>
                    </ div >
            })
        else
            setToastPerm({ show: false })
    }

    return (<QuestionnaireConfigContext.Provider value={{
        setToastPerm,
        setActiveQuestionnaire
    }}>
        {children}
    </QuestionnaireConfigContext.Provider>)
}
export default QuestionnaireConfigContext